// react
import React from "react";

import { faPencil } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Avatar from "../../../components/Avatar";

// dependencies
import PropType from "../../../lib/prop-types";

// styles
import css from "../AddFormModal.module.scss";

const Confirm = (props) => {
	const { addFormData, handleEdit } = props;
	return (
		<div className={css.modalContent}>
			<div className={css.modalDescription}>Confirm to add form to review</div>
			<div className={css.summaryItem}>
				<div className={css.itemLabel}>Review:</div>
				<div className={css.itemData}>
					<div className={`${css.name} text_truncate`}>{addFormData.review.name}</div>
					<div data-testid="edit-review-button" className={css.editIcon} onClick={() => handleEdit("review")}>
						<FontAwesomeIcon icon={faPencil} />
					</div>
				</div>
			</div>
			<div className={css.summaryItem}>
				<div className={css.itemLabel}>Form:</div>
				<div className={css.itemData}>
					<div className={`${css.name} text_truncate`}>{addFormData.form.name}</div>
					<div data-testid="edit-form-button" className={css.editIcon} onClick={() => handleEdit("form")}>
						<FontAwesomeIcon icon={faPencil} />
					</div>
				</div>
			</div>
			<div className={css.summaryItem}>
				<div className={css.itemLabel}>{addFormData.authors.length > 1 ? "Authors:" : "Author:"}</div>
				<div className={`${css.draggableWrapper} ${css.itemData}`}>
					<div className={css.authorsListContainer}>
						{addFormData.authors.map((author, ii) => (
							<div className={css.authorItem}>
								<div key={author.id} className={css.authorData}>
									<Avatar className={`${css.authorAvatar}`} id={author.id} size={20} />
									<div key={author.id} className={`${css.authorName} text_truncate`}>
										{" "}
										{author.name}
									</div>
								</div>

								{ii === 0 && !author.noEdit ? (
									<div
										data-testid="edit-authors-button"
										className={css.editIcon}
										onClick={() => handleEdit("authors")}
									>
										<FontAwesomeIcon icon={faPencil} />
									</div>
								) : null}
							</div>
						))}
					</div>
				</div>
			</div>
			{addFormData.formComment ? (
				<div className={css.summaryItem}>
					<div className={css.itemLabel}>Message:</div>
					<div className={css.itemData}>
						<div className={css.formComment}>{addFormData.formComment}</div>
						<div
							data-testid="edit-authors-button-form"
							className={css.editIcon}
							onClick={() => handleEdit("authors")}
						>
							<FontAwesomeIcon icon={faPencil} />
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
};

Confirm.propTypes = {
	addFormData: PropType.object.isRequired,
	handleEdit: PropType.func.isRequired,
};

export default Confirm;
